import React, { useContext, useLayoutEffect } from 'react'
import { store } from './store'
import { setAuthentication } from './actions/auth'
import { getValueFromCookie } from './utils'
import { AppContent } from './components/AppContent'
import { ContentLoader } from './components/ContentLoader'
import { getHasCheckedAuthentication } from './selectors/auth'

const App = () => {
  const { dispatch, state } = useContext(store)

  useLayoutEffect(() => {
    const accessToken = getValueFromCookie('v1_oauth_token', 'access_token')
    const refreshToken = getValueFromCookie('v1_oauth_refresh', 'refresh_token')
    const isAuthenticated = !!(accessToken && refreshToken)

    dispatch(setAuthentication({
      accessToken,
      hasCheckedAuthentication: true,
      isAuthenticated,
      refreshToken,
    }))
  }, [dispatch])

  return getHasCheckedAuthentication(state)
    ? <AppContent />
    : <ContentLoader />
}

export { App }
